<template>
  <div class="flex flex-col justify-center items-center bg-white h-screen">
    <img src="https://admin.atlasthq.com/logos/atlast.png" alt="logo" class="w-28 mb-3.5" />
    <div class="mt-2 w-2xs">
      <div id="google-signin-button"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ConfigKeys, getConfig } from '@/common/config'
import {
  loginWithGoogle,
  type GoogleCredentialResponse,
} from '@/modules/auth/services/auth_service'
import { onMounted } from 'vue'

// Extend Window interface to include Google API
declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (config: {
            client_id: string
            callback: (response: GoogleCredentialResponse) => void
            auto_select?: boolean
            cancel_on_tap_outside?: boolean
          }) => void
          renderButton: (
            element: HTMLElement,
            config: {
              theme?: string
              width?: string
              size?: string
              type?: string
              shape?: string
              text?: string
              logo_alignment?: string
            },
          ) => void
        }
      }
    }
    handleGoogleResponse: (response: GoogleCredentialResponse) => void
  }
}

onMounted(() => {
  // Set up global callback
  window.handleGoogleResponse = loginWithGoogle

  // Wait for Google Identity Services to load
  const initializeGoogleSignIn = () => {
    if (window.google?.accounts?.id) {
      // Initialize Google Identity Services
      window.google.accounts.id.initialize({
        client_id: getConfig(ConfigKeys.GOOGLE_CLIENT_ID),
        callback: loginWithGoogle,
        auto_select: false,
        cancel_on_tap_outside: true,
      })

      // Render the button
      const buttonElement = document.getElementById('google-signin-button')
      if (buttonElement) {
        window.google.accounts.id.renderButton(buttonElement, {
          theme: 'outline',
          width: '288',
          size: 'large',
          type: 'standard',
          shape: 'pill',
          text: 'signin_with',
          logo_alignment: 'left',
        })
      }
    } else {
      // Retry after 100ms if Google API isn't loaded yet
      setTimeout(initializeGoogleSignIn, 100)
    }
  }

  initializeGoogleSignIn()
})
</script>
